// Zero rejects every mutation while its socket is down. The outage is reported
// once by the connection reporter, so a save that hit it is not a bug of its own.
export class ZeroConnectionError extends Error {
	override name = "ZeroConnectionError"
}
